/* Vaelor: repair mis-encoded characters in supplier copy (UTF-8 read as CP1252).
   Turn 14 / Spark imports land as "FloorLinerâ„¢ DigitalFitÂ®" instead of
   "FloorLiner™ DigitalFit®". This corrects it at render time so it stays fixed
   no matter what the next sync brings in. */
(function () {
  var CP1252 = {
    0x20ac: 0x80, 0x201a: 0x82, 0x0192: 0x83, 0x201e: 0x84, 0x2026: 0x85,
    0x2020: 0x86, 0x2021: 0x87, 0x02c6: 0x88, 0x2030: 0x89, 0x0160: 0x8a,
    0x2039: 0x8b, 0x0152: 0x8c, 0x017d: 0x8e, 0x2018: 0x91, 0x2019: 0x92,
    0x201c: 0x93, 0x201d: 0x94, 0x2022: 0x95, 0x2013: 0x96, 0x2014: 0x97,
    0x02dc: 0x98, 0x2122: 0x99, 0x0161: 0x9a, 0x203a: 0x9b, 0x0153: 0x9c,
    0x017e: 0x9e, 0x0178: 0x9f
  };
  var SUSPECT = /[ÂÃâ]/;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, CODE: 1, PRE: 1, NOSCRIPT: 1 };
  var decoder = null;
  try { decoder = new TextDecoder('utf-8', { fatal: true }); } catch (e) { return; }

  function fix(s) {
    if (!s || !SUSPECT.test(s)) return s;
    var bytes = new Uint8Array(s.length);
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      if (c > 0xff) { c = CP1252[c]; if (c === undefined) return s; }
      bytes[i] = c;
    }
    try {
      var out = decoder.decode(bytes);
      return out === s ? s : out;
    } catch (e) { return s; }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { var f = fix(root.nodeValue); if (f !== root.nodeValue) root.nodeValue = f; return; }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    var it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !SUSPECT.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (p && p.nodeName && SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var batch = [], n;
    while ((n = it.nextNode())) batch.push(n);
    for (var i = 0; i < batch.length; i++) {
      var v = fix(batch[i].nodeValue);
      if (v !== batch[i].nodeValue) batch[i].nodeValue = v;
    }
  }

  function run() {
    walk(document.body);
    var t = fix(document.title);
    if (t !== document.title) document.title = t;
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) walk(added[j]);
          if (muts[i].type === 'characterData') walk(muts[i].target);
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
